const API_BASE_URL: string = import.meta.env.VITE_API_URL || "http://localhost:5190/api";

export default API_BASE_URL;
